"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appEvents = void 0;
exports.appEvents = {
    notify: 'app.notify',
    removeNotify: 'app.remove-notify',
    removeNotifyById: 'app.remove-notify-by-id',
    menuToggle: 'app.menu.toggle',
    setMenuState: 'app.menu.set-state',
    darkModeToggle: 'app.dark-mode.toggle',
    logout: 'app.logout',
    login: 'app.login',
    authExpired: 'rws:auth:expired',
    openKnowledgeModal: 'app.knowledge.modal.open',
    openUserGroupModal: 'app.user-group.modal.open',
    injectMessages: 'chat.inject.messages',
    frontChatConversationStart: 'chat:conversation:start',
    frontChatConversationEnd: 'chat:conversation:end',
    frontChatWebSearch: 'chat:web-search',
    frontChatDeepSearch: 'chat:deep-search',
    frontChatAudioRecord: 'chat:audio:record',
    frontChatWritingStyleChange: 'chat:writing-style:change',
    codeViewerClosePreview: 'code-viewer.close-preview',
    codeViewerDownloadHtml: 'code-viewer.download-html',
    popupShow: 'popup:show',
    triggerSelected: 'autocomplete:trigger:selected',
    autocompleteStateChange: 'autocomplete:state:change'
};
